<template>
    <div v-if="$route.meta.showLiveStream">
        <div class="live-tream-container">
            <div class="row header-container" @click="handleShowLiveStream">
                <div class="col-9">
                    <h3 class="header--title">
                        <i class="bi bi-youtube"></i>
                        {{ getTranslatedText('live stream') }}
                    </h3>
                </div>
                <div class="col-3 d-flex justify-content-end align-items-center header--icon">
                    <p>
                        <i :class="isShowLiveStream ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </p>
                </div>
            </div>
            <div class="row content-live-stream" v-show="isShowLiveStream">
                <div class="col-12">
                    <div class="message-container" v-if="!isLogin || hasError">
                        <p>
                            {{ !isLogin
                                ? getTranslatedText('please log in to watch the live stream')
                                : getTranslatedText('Live streaming will be available shortly before the scheduled start time')
                            }}
                        </p>
                    </div>
                    <div v-else-if="!embedUrl">
                        <p>
                            {{ getTranslatedText('There is no race available to watch live stream') }}
                        </p>
                    </div>
                    <div v-else class="px-1">
                        <div class="iframe-wrapper">
                            <iframe
                                :src="embedUrl"
                                class="responsive-iframe"
                                frameborder="0"
                                scrolling="no"
                                allowfullscreen
                                allow="autoplay"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="horizontal-line" />
    </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import LiveStreamService from '@/services/live-stream/index.service'
import { isObjEmpty } from "@/utils/utils";

export default {
    mixins: [languageMixins],
    data() {
        return {
            data: {},
            hasError: false,
            isShowLiveStream: true,     
            intervalTimer: [],
            embedUrl: '',
        }
    },
    watch: {
        '$store.state.race': {
            handler(newRace, oldRace) {
                if (isObjEmpty(newRace))  {
                    this.handleClearInterval()
                    this.embedUrl = ''
                    this.hasError = false
                }
                if (newRace && oldRace && newRace.race_id != oldRace.race_id) {
                    this.handleGetLink()
                    this.handleClearInterval()
                    this.handleInitIntervalTimer()
                }
            },
            deep: true,
        },
        '$store.state.settings.currentGame': {
            handler(newGame, oldGame) {
                if (newGame && oldGame && newGame != oldGame) {
                    this.handleGetLink()
                    this.handleClearInterval()
                    this.handleInitIntervalTimer()
                }
            },
            deep: true,
        }
    },
    created() {
        this.handleGetLink()
    },
    computed: {
        isLogin() {
            return this.$store.state.isLogin
        }
    },
    methods: {
        async handleGetLink() {
            if (!this.isLogin) return;
            try {
                let streamId = this.$store.state.race?.race_external_id;
                if (!streamId) return;
                let {status, data} = await LiveStreamService.getLinkLiveStream(streamId);

                if (status == "success") {
                    this.hasError = data.error || false;
                    this.embedUrl = data.embedUrl || data.phenixEmbedUrl;
                    if (!this.embedUrl) {
                        this.handleClearInterval()
                        this.handleInitIntervalTimer()
                    }
                }
            } catch (error) {
                console.log("error", error)
            }
        },

        handleInitIntervalTimer() {
            this.intervalTimer.push(setInterval(() => {
                this.checkTimeToGetLinkLiveStream()
            }, 30000))
        },

        handleShowLiveStream() {
            this.isShowLiveStream = !this.isShowLiveStream
        },

        checkTimeToGetLinkLiveStream() {
            const raceTime = this.$store.state.race?.race_time;
            if (!raceTime) return;
            const options = {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
                timeZone: this.$store.state.settings.timeZone,
            };
            const nowLocalTime = new Date();
            const startTimeLocalTime = new Date(raceTime.toLocaleString('en-US', options));
            // // Check if the current time is 5 minutes or more before the start time
            if (nowLocalTime.getTime() >= startTimeLocalTime.getTime() - 5 * 60 * 1000) {
                this.handleGetLink()
            }
        },

        handleClearInterval() {
            if (this.intervalTimer.length > 0) {
                this.intervalTimer.forEach((item) => clearInterval(item))

                this.intervalTimer = []
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/public/scss/components/live-stream.scss";
</style>
